import { ILatLng } from "polydraw";
import { EvAreaType } from "src/app/infopage/models/area-type.enum";
import { FilterType } from "src/models/shared/filter.model";
import { EVEstateType, EVOwnership, EVSiteTypeNorwegian } from "src/models/units/unit-attributes.model";

export interface StoredMarketFilterModel extends MarketFilterModel {
    filterType: FilterType;
    name: string;
    unitIds: number[];
    id?: number;
}

export interface MarketFilterModel {
    estateTypes: EVEstateType[];
    ownershipTypes: EVOwnership[];
    plotOwnershipTypes: EVSiteTypeNorwegian[];
    periodDefinitionType?: PeriodDefinitionType | null;
    fromDate: Date | null;
    toDate: Date | null;
    includeAgentSales: boolean | null;
    includeJudicialTransfers: boolean | null;
    includeWithDrawnPrices: boolean | null;
    includeUnCertainPrices: boolean | null;
    isSitePrice: boolean | null;
    isForSale: boolean | null;
    priceFrom: number | null;
    priceTo: number | null;
    unitAreaFrom: number | null;
    unitAreaTo: number | null;
    buildYearFrom: number | null;
    buildYearTo: number | null;
    numberOfBedroomFrom: number | null;
    numberOfBedroomTo: number | null;
    floorNumberFrom: number | null;
    floorNumberTo: number | null;
    plotAreaFrom: number | null;
    plotAreaTo: number | null;
    estateAgentHeadOfficeId: number | null;
    hasElevator: boolean | null;
    hasParking: boolean | null;
    hasBalcony: boolean | null;
    monthsBackInTime: number | null;
    timeOnMarketFrom: number | null;
    timeOnMarketTo: number | null;
    isWithDrawn: boolean | null;
    sqmPriceFrom: number | null;
    sqmPriceTo: number | null;
    energyLabels: string[];
    isGreenHome: boolean | null;
    greenHomeBasisTypes: GreenHomeBasisType[];
    areas?: TemporaryArea[] | null;
    sortOrder?: string | null;
    geoBorder?: ILatLng[][][] | null;
    isOwnedByCompany: boolean;
}


export enum PeriodDefinitionType {
    Registered = 1,
    Sold = 2,
    InMarket = 3
}

export interface TemporaryArea {
    areaType: EvAreaType;
    areaId: number;
    name?: string;
    number?: number;
    geographicBorder: ILatLng[][][],
    parentAreaType?: EvAreaType;
    parentAreaId?: number;
}

export enum GreenHomeBasisType {
    EnergyLabelA = 1,
    Top15 = 2,
    NZEB = 3,
    EnergyImprovement30 = 4
}
